import { StackView, Text, ToggleSwitch, Box, Button, Collapse } from '@planningcenter/tapestry-react';
import React from 'react';
import { useChannelMute } from '../../hooks/use_channel_mute.js';
import 'stream-chat-react';
import { noop } from '../../utils/index.js';
import { useChat } from '../../hooks/use_chat.js';
import { useChatApi } from '../../hooks/use_chat_api.js';
import '@planningcenter/url';
import '@planningcenter/jolt-client';
import 'stream-chat';
import { Section } from './section.js';

const MuteChannel = ({ channel }) => {
    const muted = useChannelMute(channel);
    return (React.createElement(StackView, { axis: "horizontal", width: "100%" },
        React.createElement(Text, { as: "label", display: "flex", grow: 1 },
            "Mute",
            React.createElement(StackView, { grow: 1 }),
            React.createElement(ToggleSwitch, { isChecked: muted, ariaLabel: "Mute Channel", onClick: () => muted ? channel.unmute() : channel.mute() }))));
};
const RemoveChannel = ({ channel }) => {
    const [isRemoveHot, setRemoveHot] = React.useState(false);
    const [isRemoving, setRemoving] = React.useState(false);
    const { navigation } = useChat();
    const api = useChatApi();
    return (React.createElement(Box, null,
        !isRemoveHot && (React.createElement(Button, { onClick: () => setRemoveHot(true), paddingHorizontal: 0, paddingVertical: 0, theme: false },
            React.createElement(Text, { color: "error" }, "Delete conversation"))),
        React.createElement(Collapse, { open: isRemoveHot, instant: true },
            React.createElement(StackView, { backgroundColor: "error-lightest", padding: 2, radius: 4, spacing: 1 },
                React.createElement(Text, { size: 4 }, "Deleting this conversation will remove it for everyone. This cannot be undone. Are you sure?"),
                React.createElement(StackView, { distribution: "end", alignment: "end", axis: "horizontal", spacing: 1 },
                    React.createElement(Button, { fontWeight: 400, onClick: () => setRemoveHot(false), size: "sm", theme: "dark", variant: "naked" }, "Cancel"),
                    React.createElement(Button, { disabled: isRemoving, fontWeight: 400, onMouseDown: (e) => e.preventDefault(), onClick: () => {
                            setRemoving(true);
                            api.chat
                                .delete(`me/conversations/${channel.id}`)
                                .then(navigation.switchToChannelListView)
                                .catch(noop);
                        }, size: "sm", theme: "error", title: "Yes, delete", spinner: isRemoving }))))));
};
const Settings = ({ channel, isRemovable }) => (React.createElement(Section, { title: "Settings" },
    React.createElement(StackView, { spacing: 1 },
        React.createElement(MuteChannel, { channel: channel }),
        isRemovable && React.createElement(RemoveChannel, { channel: channel }))));

export { Settings };
//# sourceMappingURL=settings.js.map
